/* eslint-disable max-len */
import React from 'react';
function ClaimIcon({
  width = 24,
  height = 24,
  ...rest
}: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      viewBox="0 0 75 75"
      preserveAspectRatio="xMidYMid meet"
      {...rest}>
      <g fill="currentColor" stroke="none">
        <path
          style={{opacity: 0.644}}
          d="M 24.5,0.5 C 38.1707,0.333432 51.8374,0.500099 65.5,1C 70.4935,4.15014 74.1601,8.31681 76.5,13.5C 72.4862,13.6655 68.4862,13.4988 64.5,13C 63.518,9.70736 63.518,6.70736 64.5,4C 52.1712,3.50012 39.8378,3.33346 27.5,3.5C 27.6665,13.8387 27.4998,24.172 27,34.5C 26.586,34.9574 26.086,35.2907 25.5,35.5C 24.5011,23.8523 24.1678,12.1857 24.5,0.5 Z"
        />
        <path
          style={{opacity: 0.657}}
          d="M 73.5,14.5 C 74.5,14.5 75.5,14.5 76.5,14.5C 76.5,34.8333 76.5,55.1667 76.5,75.5C 65.8126,75.832 55.1459,75.4987 44.5,74.5C 44.7093,73.914 45.0426,73.414 45.5,73C 54.8274,72.5002 64.1607,72.3335 73.5,72.5C 73.5,53.1667 73.5,33.8333 73.5,14.5 Z"
        />
        <path
          style={{opacity: 0.629}}
          d="M 42.5,16.5 C 47.8333,16.5 53.1667,16.5 58.5,16.5C 58.5,17.5 58.5,18.5 58.5,19.5C 53.1667,19.5 47.8333,19.5 42.5,19.5C 42.5,18.5 42.5,17.5 42.5,16.5 Z"
        />
        <path
          style={{opacity: 0.646}}
          d="M 32.5,24.5 C 44.9937,24.0214 57.327,24.5214 69.5,26C 63.1635,27.1499 56.6635,27.6499 50,27.5C 43.8333,27.1667 37.6667,26.8333 31.5,26.5C 31.8627,25.8165 32.1961,25.1499 32.5,24.5 Z"
        />
        <path
          style={{opacity: 0.646}}
          d="M 31.5,31.5 C 44.3264,31.0208 56.9931,31.5208 69.5,33C 57.3226,34.6438 44.9893,34.9771 32.5,34C 31.7476,33.3292 31.4142,32.4959 31.5,31.5 Z"
        />
        <path
          style={{opacity: 0.642}}
          d="M 23.5,36.5 C 27.7917,36.5647 31.6251,37.8981 35,40.5C 35.0599,43.3963 34.2266,46.063 32.5,48.5C 35.1619,50.9317 37.9953,53.2651 41,55.5C 41.6667,56.8333 42.3333,58.1667 43,59.5C 43.1327,66.2136 43.2994,72.8803 43.5,79.5C 43.4712,81.0293 42.8045,82.196 41.5,83C 30.59,83.8196 19.7567,83.6529 9,82.5C 7.17063,80.1065 7.3373,77.7732 9.5,75.5C 4.87948,63.5152 8.21281,54.6819 19.5,49C 17.2157,46.2586 16.2157,43.0919 16.5,39.5C 19.4815,39.8176 21.8148,38.8176 23.5,36.5 Z"
        />
        <path
          style={{opacity: 0.643}}
          d="M 36.5,37.5 C 47.663,37.0242 58.663,37.5242 69.5,39C 58.663,40.4758 47.663,40.9758 36.5,40.5C 36.5,39.5 36.5,38.5 36.5,37.5 Z"
        />
        <path
          style={{opacity: 0.645}}
          d="M 38.5,43.5 C 48.9979,43.0259 59.3312,43.5259 69.5,45C 59.3261,46.639 48.9927,46.9724 38.5,46C 37.4019,45.2303 37.4019,44.397 38.5,43.5 Z"
        />
        <path
          style={{opacity: 0.546}}
          d="M 63.5,52.5 C 64.5,52.5 65.5,52.5 66.5,52.5C 65.7212,57.121 63.0545,59.2877 58.5,59C 57.2528,57.5064 57.2528,56.0064 58.5,54.5C 60.8668,55.822 62.5335,55.1553 63.5,52.5 Z"
        />
        <path
          style={{opacity: 0.608}}
          d="M 27.5,62.5 C 31.4573,65.416 31.4573,68.416 27.5,71.5C 26.5,72.8333 25.5,72.8333 24.5,71.5C 23.0499,70.1502 22.3832,68.4835 22.5,66.5C 28.3783,67.9141 28.7116,67.4141 23.5,65C 20.8456,61.4112 21.6789,58.5778 26,56.5C 27.7024,57.3687 28.869,58.7021 29.5,60.5C 29.2528,61.7133 28.5862,62.38 27.5,62.5 Z"
        />
        <path
          style={{opacity: 0.611}}
          d="M 54.5,60.5 C 59.6912,60.0585 64.6912,60.5585 69.5,62C 66.8605,63.1182 64.0272,63.6182 61,63.5C 58.5,63.1667 56,62.8333 53.5,62.5C 53.8627,61.8165 54.1961,61.1499 54.5,60.5 Z"
        />
      </g>
    </svg>
  );
}

export default ClaimIcon;
